<template>
  <div class="login-page">
    <div class="container main-container animate__animated animate__fadeIn">
      <div class="row align-items-center h-100">
        <div class="col-md-6 pt-5 pt-md-0">
          <div class="d-flex align-items-center">
            <img
              src="@/core/assets/images/layout/logo-admin.png"
              alt="Zet - Libro de reclamaciones online"
              class="logo"
            />
            <span class="logo-title">ZET</span>
          </div>

          <p class="description mt-3">Restablecer contraseña</p>

          <ResetPasswordForm @reset="showFormReset = true" />
        </div>

        <div class="col-md-6 pb-5 pb-md-0">
          <div class="carousel text-center pb-5 pb-md-0">
            <swiper class="swiper relative" :options="swiperOptions">
              <swiper-slide class="d-flex flex-column justify-content-center align-items-center">
                <img
                  src="@/core/assets/images/login/login-image-1.png"
                  alt="Zet - Libro de reclamaciones online"
                  class="img-fluid"
                />

                <div class="carousel-content text-center">
                  <p class="carousel-title mb-1">
                    Cumple con la ley sin complicaciones
                  </p>
                  <p class="carousel-description my-0">
                    Nuestra plataforma de Libro de Reclamaciones Digital te permite cumplir con la normativa vigente de INDECOPI
                  </p>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>

    <RecoverPasswordModal @hide="showFormReset = false" :show="showFormReset"/>
  </div>
</template>

<script>
// import { SecurityService } from "@/core/services";
// import { ErrorUtils, SSOUtils } from "wize-admin";

import ResetPasswordForm from "../Components/ResetPasswordForm.vue";
import RecoverPasswordModal from '../Components/RecoverPasswordModal.vue';

export default {
  name: "LoginPage",
  data() {
    return {
      error: false,
      errorMsg: null,
      swiperOptions: {
        loop: false
      },
      showFormReset: false
    };
  },
  components: {
    ResetPasswordForm,
    RecoverPasswordModal
  },
  methods: {
    // loginSso() {
    //   this.errorMsg = null;
    //   this.loading = true;
    //   this.$store.commit("app/setLoading", true);
    //   const callbackParams = SSOUtils.getCallbackParameters(location.href);
    //   if (this.$store.getters["auth/getSsoState"] === callbackParams.state) {
    //     this.$store.commit("auth/ssoState", null);
    //     SecurityService.loginSSO(callbackParams)
    //       .then(async (response) => {
    //         if (response.status !== "OK") {
    //           return (this.errorMsg = ErrorUtils.getErrorMessages(response));
    //         }
    //         await this.$store.dispatch("auth/setAuthInfo", response.payload);
    //         await this.$store.dispatch("app/loadStartupData");
    //         await this.$router.push({ name: "businesses" });
    //       })
    //       .catch((err) => {
    //         console.error(err);
    //         // this.errorMsg = ErrorUtils.getErrorMessages(err);
    //       })
    //       .finally(() => this.$store.commit("app/setLoading", false));
    //   } else {
    //     this.errorMsg =
    //       "El estado SSO no coincide, por favor intenta nuevamente";
    //   }
    // },
  },
};
</script>

<style lang="stylus">
@import '../Styles/login-page';
</style>